<template>
  <div class="piece-box inner-content department-attendance">
    <div class="piece-box-title flex-box align-center">
      <div class="flex-grow">考勤统计</div>
      <piece-tab v-model="type" :tabs="personTypes"></piece-tab>
    </div>
    <div class="department-attendance-chart"></div>
  </div>
</template>

<script>
    import * as echarts from "echarts";
    import pieceTab from "../../../components/piece-tab";
    const options = {
        title: {
            top: "middle",
            left: "34%",
            textVerticalAlign: "top",
            textAlign: "center",
            text: 223,
            subtext: "应到人数"
        },
        legend: {
            orient: "vertical",
            top: "middle",
            right: "5%",
        },
        series: [
            {
                name: '考勤统计',
                type: 'pie',
                radius: ['50%', '80%'],
                center: ['35%', '50%'],
                avoidLabelOverlap: false,
                itemStyle: {
                    borderRadius: 10,
                    borderColor: '#fff',
                    borderWidth: 2
                },
                label: {
                    position: 'inside',
                    formatter: params => params.value > 0 ? `${params.value}人` : "",
                },
                labelLine: {
                    show: false
                },
                data: []
            }
        ]
    };
    export default{
        name: "DepartmentAttendance",
        components: {
            pieceTab
        },
        props: {
            number: Array
        },
        data() {
            return {
                type: 1,
            }
        },
        computed: {
            personTypes() {
                const res = [
                    {
                        key: 1,
                        title: "僧众",
                        total: 0,
                        totalTitle: "应到人数",
                        count: [
                            { value: 0, name: "在寺" },
                            { value: 0, name: "请假" },
                            { value: 0, name: "外派" },
                        ]
                    },
                    {
                        key: 2,
                        title: "职工",
                        total: 0,
                        totalTitle: "应到人数",
                        count: [
                            { value: 0, name: "在寺" },
                            { value: 0, name: "请假" },
                            { value: 0, name: "外派" },
                        ]
                    },
                ];
                const number = this.number;
                if(number) {
                    res.forEach((item, i) => {
                        const count = number[i]?.count;
                        if(count) {
                            item.count.forEach((c, j) => c.value = count[j + 1] || 0);
                            item.total = count[0] || 0;
                        }
                    });
                }
                return res;
            }
        },
        watch: {
            type() {
                this.initChart();
            },
            personTypes() {
                this.initChart();
            }
        },
        mounted() {
            this.initChart();
        },
        methods: {
            initChart() {
                if(!this.chart) {
                    this.chart = echarts.init(this.$el.querySelector(".department-attendance-chart"));
                }
                const type = this.personTypes.find(t => t.key == this.type);
                if(type) {
                    options.title.text = type.total;
                    options.title.subtext = type.totalTitle;
                    options.series[0].data = [...type.count];
                }
                this.chart.setOption(options);
            }
        }
    }
</script>

<style lang="less">
.department-attendance-chart {
  height: 265px;
}
</style>
